<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between">
          <h1>Все флористы</h1>
          <va-button color="info" @click="showModal = true">
            Добавить флориста
          </va-button>
        </div>
      </va-card>

      <florists-table class="mb-4" :florists="florists" @refresh="loadFlorists" />
      <va-modal v-model="showModal" hide-default-actions>
        <florist-create @close="showModal = false" @created="handleCreated"></florist-create>
      </va-modal>
    </va-inner-loading>
  </div>
</template>

<script>
import FloristCreate from '../../components/florists/florist-create.vue';
import FloristsTable from '../../components/florists/florists-table.vue';
import api from '@/api/axios';
import { mapGetters } from 'vuex';

export default {
  name: 'Florists',
  components: { FloristCreate, FloristsTable },
  data() {
    return {
      showModal: false,
      florists: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      loader: 'isLoading',
    }),
  },
  async created() {
    await this.loadFlorists();
  },
  methods: {
    async loadFlorists() {
      this.loading = true;
      try {
        const response = await api.get('/admin/florists', { params: { all: 1 } });
        // Обрабатываем как пагинацию, так и простой массив
        this.florists = response.data.data || response.data || [];
      } catch (error) {
        console.error('Ошибка загрузки флористов:', error);
        this.florists = [];
      } finally {
        this.loading = false;
      }
    },
    handleCreated() {
      this.showModal = false;
      this.loadFlorists();
    },
  },
};
</script>

<style></style>

